import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import { IndexWrapper, Erc1155Section, Erc1155Contract, Erc1155Template, ServiceType } from "@framework/shared";

export const erc1155Routes: Array<RouteObject> = [
  {
    path: "/erc1155",
    children: [
      {
        index: true,
        element: (
          <IndexWrapper index="erc1155">
            <Erc1155Section />
          </IndexWrapper>
        ),
      },
      {
        path: "/erc1155/contracts",
        element: <Protected />,
        children: [
          { index: true, element: <Erc1155Contract service={ServiceType.OFFICE} /> },
          { path: "/erc1155/contracts/:id/:action", element: <Erc1155Contract service={ServiceType.OFFICE} /> },
        ],
      },
      {
        path: "/erc1155/templates",
        element: <Protected />,
        children: [
          { index: true, element: <Erc1155Template service={ServiceType.OFFICE} /> },

          { path: "/erc1155/templates/:id/:action", element: <Erc1155Template service={ServiceType.OFFICE} /> },
        ],
      },
    ],
  },
];
